import { Box, IconButton, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const EventContentWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  justifyContent: 'space-between',
});

export const EventDetailsContainer = styled(Box)({
  display: 'flex',
  gap: 1,
});

export const ApprovalButton = styled(IconButton)(({ theme, color }) => ({
  '&:hover': {
    backgroundColor: theme.palette[color].light,
    color: theme.palette.common.white,
  },
}));

export const StyledDescriptionText = styled(Typography)(({ theme }) => ({
  color: theme.colors.gray,
  fontSize: '14px',
  fontWeight: '400',
  lineHeight: '20px',
  padding: theme.spacing(0, 1),
}));

export const StyledTitleText = styled(Typography)(({ theme }) => ({
  color: theme.colors.red,
  alignSelf: 'flex-start',
  padding: theme.spacing(0, 1),
}));
